module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-container"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "padding": "5px 0"
    }
  }, [_c('h1', {
    staticClass: "m-name"
  }, [_vm._v("[" + _vm._s(_vm.student.id) + "] " + _vm._s(_vm.student.f_name) + " " + _vm._s(_vm.student.l_name) + "(" + _vm._s(_vm.student.f_name_kana) + " " + _vm._s(_vm.student.l_name_kana) + ") 様")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "loading",
      "mode": "out-in"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'familyindex',
        params: {
          id: _vm.student.family.id
        },
        exact: true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])], 1)], 1), _vm._v(" "), _c('section-navi', [_c('section-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'studentindex',
        params: {
          id: _vm.student.id
        },
        exact: true
      },
      "exact": ""
    }
  }, [_vm._v("データ")])], 1), _vm._v(" "), _c('section-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.getGeo($event)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'studentmap',
        params: {
          id: _vm.student.id
        },
        exact: true
      }
    }
  }, [_vm._v("地図")])], 1), _vm._v(" "), _c('section-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'studenthistory',
        params: {
          id: _vm.student.id
        },
        exact: true
      }
    }
  }, [_vm._v("対応履歴")])], 1), _vm._v(" "), _c('section-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'studentfileview',
        params: {
          id: _vm.student.id
        },
        exact: true
      }
    }
  }, [_vm._v("生徒ファイル")])], 1), _vm._v(" "), _c('section-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'studentagreements',
        params: {
          id: _vm.student.id
        },
        exact: true
      }
    }
  }, [_vm._v("契約内容")])], 1)], 1), _vm._v(" "), _c('router-view', {
    attrs: {
      "student": _vm.student,
      "condition": _vm.condition,
      "edit_id": _vm.edit_id
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f976793"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Student/Student.vue
// module id = 1406
// module chunks = 0